import { useEffect, useRef } from "react";
import { toast } from "sonner";
import { CheckCircle2 } from "lucide-react";
import { useI18n } from "../lib/i18n";
import { useInstalledState } from "../lib/useInstalledState";

const TOAST_SHOWN_KEY = "lh2o_pwa_installed_toast_shown";

/**
 * Side-effect-only component. The first time we ever detect that the PWA
 * is installed (either via `appinstalled` or by being launched in
 * standalone mode), we show a single celebratory toast. A localStorage
 * flag prevents the toast from re-appearing on every load.
 */
export default function InstalledToast() {
  const installed = useInstalledState();
  const { t } = useI18n();
  const firedRef = useRef(false);

  useEffect(() => {
    if (!installed || firedRef.current) return;
    let alreadyShown = false;
    try {
      alreadyShown = localStorage.getItem(TOAST_SHOWN_KEY) === "1";
    } catch (_) { /* ignore */ }
    if (alreadyShown) return;
    firedRef.current = true;
    try {
      localStorage.setItem(TOAST_SHOWN_KEY, "1");
    } catch (_) { /* ignore */ }
    toast.success(t("install.installed_toast"), {
      icon: <CheckCircle2 className="w-4 h-4" />,
      duration: 4500,
    });
  }, [installed, t]);

  return null;
}
